<div class="sidebar">
  <rds-sidenav [isExpandable]="false">
    <a rds-sidenav-menuitem routerLink="my-offerings" routerLinkActive="active">
      <rds-icon namespace="outlined" icon="device_screen" />
      My offerings
    </a>
    <a
      *inexpFeatureFlag="'focus_inexp_2522_form_manager'"
      rds-sidenav-menuitem
      href="/film/form-manager"
    >
    <rds-icon namespace="outlined" icon="file_google_forms"/>
    Form manager
    </a>
  </rds-sidenav>
</div>
